import React from "react";
import useStyles from "./styles";
import { useHistory } from "react-router-dom";
import Slider from "react-slick";

import { dashboardOptions } from "./empDashboardOptions";

const EmployeeNavTab = () => {
  const classes = useStyles();

  const settings = {
    dots: true,
    infinite: true,
    indicators: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          className: "center",
          centerMode: true,
        },
      },
    ],
  };

  const history = useHistory();

  return (
    <div
      className="slider-container"
      style={{ maxWidth: "800px", margin: "auto" }}
    >
      <Slider {...settings}>
        {dashboardOptions.map((item, index) => (
          <div key={index}>
            <img
              src={item.image}
              onClick={() => history.push(item.link)}
              loading="lazy"
              style={{
                borderRadius:"8px",
                cursor:"pointer",
                width: "80%",
                height: "60px",
                objectFit: "cover"
              }}
              className="emp-navbar-tab-tooltip-img-icon"
              width="100%"
              height="100%"
              alt="image_logo"
            />
            <span 
              style={{
                width: "80%",
                whiteSpace:"nowrap",
                overflow: "hidden",
                textOverflow:"ellipsis",
                display:"inline-block"
              }}
            >{item.label} </span>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default EmployeeNavTab;

{
  /* <div className="emp-navbar-tab-button-container">
{subMenu.map((item, index) => (
  <InformationTooltip
    title={
      <React.Fragment>
        {!imageLoaded && <div className="skeleton-img-loader" />}
        <img
          src={item.image}
          loading="lazy"
          onLoad={() => setImageLoaded(true)}
          className="emp-navbar-tab-tooltip-img-icon"
          style={{ display: imageLoaded ? "block" : "none" }}
          width="100%"
          height="100%"
          alt="image_logo"
        />
        <Typography color="inherit" style={{ fontSize: "12px" }}>
          {item.label}
        </Typography>
      </React.Fragment>
    }
    placement="bottom"
  >
    <div
      className="emp-navbar-tab-button"
      onClick={() => history.push(item.link)}
    >
      <span>{index + 1}</span>
    </div>
  </InformationTooltip>
))}

</div> */
}
